import { Users } from 'lucide-react';

interface FollowerGrowthProps {
  totalFollowers: number;
  recentFollowers: { id: string; firstName: string | null; lastName: string | null; avatarUrl: string | null; followedAt: Date }[];
}

export function FollowerGrowth({ totalFollowers, recentFollowers }: FollowerGrowthProps) {
  return (
    <div
      className="rounded-2xl p-5"
      style={{
        background: 'rgba(255,255,255,0.7)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(148,163,184,0.2)',
      }}
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-slate-700">Followers</h3>
        <Users size={16} className="text-slate-400" />
      </div>
      <p className="text-3xl font-bold text-slate-900 mb-3">
        {totalFollowers >= 1000 ? `${(totalFollowers / 1000).toFixed(1)}K` : totalFollowers}
      </p>
      {recentFollowers.length > 0 && (
        <div className="space-y-2">
          <p className="text-[10px] font-medium text-slate-400 uppercase tracking-wider">Recent</p>
          <div className="flex -space-x-2">
            {recentFollowers.slice(0, 5).map((f) => (
              <div
                key={f.id}
                className="h-7 w-7 rounded-full bg-gradient-to-br from-indigo-400 to-purple-500 ring-2 ring-white flex items-center justify-center text-[10px] font-bold text-white"
                title={`${f.firstName || ''} ${f.lastName || ''}`}
              >
                {f.firstName?.[0] || '?'}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
